// @flow

import React from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import history from "./history";
import * as V3Account from "./v3/account/";
import * as Admin from "./v3/admin/";

const profileBase = "/";
const accountBase = "/account/";
const adminBase = "/admin/";
const docBase = "/document/";

const ProfilePages = (): React$Element<*> => {
  return (
    <V3Account.PageContainer>
      <Switch>
        <Route
          exact
          path={profileBase + "signup"}
          component={V3Account.Switch}
        />
        <Route
          exact
          path={profileBase + "login"}
          component={V3Account.Switch}
        />
        <Route
          exact
          path={profileBase + "logoff"}
          component={V3Account.Switch}
        />
        <Route
          exact
          path={profileBase + "forgot"}
          component={V3Account.Forgot}
        />
        <Route
          exact
          path={profileBase + "forgot2"}
          component={V3Account.ForgotUser}
        />
        <Route
          exact
          path={profileBase + "forgot2/:token"}
          component={V3Account.ForgotUser}
        />
        <Route
          exact
          path={profileBase + "invite/:token"}
          component={V3Account.Invite}
        />
        <Redirect to={profileBase + "login"} />
      </Switch>
    </V3Account.PageContainer>
  );
};

const AccountPages = (): React$Element<*> => {
  return (
    <V3Account.Template>
      <Switch>
        <Route
          exact
          path={accountBase + "profile"}
          component={V3Account.Profile}
        />
        <Route
          exact
          path={accountBase + "licence"}
          component={V3Account.Licence}
        />
        <Route
          exact
          path={accountBase + "company"}
          component={V3Account.Company}
        />
        <Route
          exact
          path={accountBase + "facesearch"}
          component={V3Account.FaceSearch}
        />
        <Route
          exact
          path={accountBase + "people"}
          component={V3Account.People}
        />
        <Route
          exact
          path={accountBase + "project"}
          component={V3Account.Project}
        />
        <Route
          exact
          path={accountBase + "project/:token"}
          component={V3Account.Project}
        />
        {/* <Route exact path={accountBase + "quote"} component={V3Account.Quote} /> */}
        <Route
          exact
          path={accountBase + "quote/:token"}
          component={V3Account.Quote}
        />
        <Route
          exact
          path={accountBase + "software"}
          component={V3Account.Softwares}
        />
        <Route
          exact
          path={accountBase + "billing"}
          component={V3Account.Billing}
        />
        {/*admin*/}
        <Route
          exact
          path={adminBase + "resellers"}
          component={Admin.Resellers}
        />
        <Route exact path={adminBase + "licences"} component={Admin.Licences} />
        <Route exact path={adminBase + "projects"} component={Admin.Projects} />
        <Route exact path={adminBase + "quotes"} component={Admin.Quotes} />
        <Route
          exact
          path={adminBase + "companies"}
          component={Admin.Companies}
        />
        <Route
          exact
          path={adminBase + "facebases"}
          component={Admin.Facebases}
        />
        <Route exact path={adminBase + "users"} component={Admin.Users} />
        <Route exact path={adminBase + "billings"} component={Admin.Billings} />
        {/*doc*/}
        <Route exact path={docBase + "api"} component={Admin.ApiDocument} />
        <Route exact path={docBase + "auth"} component={Admin.AuthDocument} />
        <Route
          exact
          path={docBase + "graphql"}
          component={Admin.GraphQlDocument}
        />
        <Route
          exact
          path={docBase + "software"}
          render={(props: SoftwareDocumentIframePropsType): React$Element<*> => (
            <Admin.SoftwareDocumentIframe {...props}
              src="documentation/" />
          )}
        />
        <Route
          exact
          path={docBase + "guides"}
          render={(props: SoftwareDocumentIframePropsType): React$Element<*> => (
            <Admin.SoftwareDocumentIframe {...props}
              src="guides/" />
          )}
        />
        <Redirect to={accountBase + "profile"} />
      </Switch>
    </V3Account.Template>
  );
};

const PageRoute = (): React$Element<*> => (
  <Router history={history}>
    <Switch>
      <Route path="/account" component={AccountPages} />
      <Route path="/admin" component={AccountPages} />
      <Route path="/document" component={AccountPages} />
      <Route path="" component={ProfilePages} />
    </Switch>
  </Router>
);

export default PageRoute;
